import { FilterOption } from '../interfaces';
import {
  CALENDAR_EVENT_TYPES,
  CalendarEventType,
  DEPOSIT_STATUS_VALUES,
  DepositFilterStatus,
} from '../types/calendar';

export const DEFAULT_EVENT_CALENDAR_TYPES: CalendarEventType[] = [
  CALENDAR_EVENT_TYPES.SCHEDULED_APPOINTMENTS,
  CALENDAR_EVENT_TYPES.CANCELLED_APPOINTMENTS,
  CALENDAR_EVENT_TYPES.TIME_BLOCKS,
  CALENDAR_EVENT_TYPES.TRIPS,
  CALENDAR_EVENT_TYPES.FLASH_DAYS,
  CALENDAR_EVENT_TYPES.UNAVAILABLE_TIMES,
];

export const CALENDAR_EVENT_OPTIONS: FilterOption[] = [
  {
    label: 'Scheduled Appointments',
    value: CALENDAR_EVENT_TYPES.SCHEDULED_APPOINTMENTS,
  },
  {
    label: 'Cancelled Appointments',
    value: CALENDAR_EVENT_TYPES.CANCELLED_APPOINTMENTS,
  },
  {
    label: 'Time Blocks',
    value: CALENDAR_EVENT_TYPES.TIME_BLOCKS,
  },
  {
    label: 'Trips',
    value: CALENDAR_EVENT_TYPES.TRIPS,
  },
  {
    label: 'Flash Days',
    value: CALENDAR_EVENT_TYPES.FLASH_DAYS,
  },
  {
    label: 'External Calendar Events',
    value: CALENDAR_EVENT_TYPES.UNAVAILABLE_TIMES,
  },
];

export const WAIVER_STATUS_VALUES = {
  SIGNED: 'signed',
  PENDING: 'pending',
  NO_WAIVER: 'no-waiver',
} as const;

export type WaiverFilterStatus =
  (typeof WAIVER_STATUS_VALUES)[keyof typeof WAIVER_STATUS_VALUES];

export const WAIVER_STATUS_OPTIONS: FilterOption<WaiverFilterStatus>[] = [
  { label: 'Signed', value: WAIVER_STATUS_VALUES.SIGNED },
  { label: 'Pending', value: WAIVER_STATUS_VALUES.PENDING },
  { label: 'No Waiver', value: WAIVER_STATUS_VALUES.NO_WAIVER },
];

export const DEFAULT_WAIVER_STATUSES: WaiverFilterStatus[] = [
  WAIVER_STATUS_VALUES.SIGNED,
  WAIVER_STATUS_VALUES.PENDING,
  WAIVER_STATUS_VALUES.NO_WAIVER,
];

export const DEPOSIT_STATUS_OPTIONS: FilterOption<DepositFilterStatus>[] = [
  { label: 'All', value: DEPOSIT_STATUS_VALUES.ALL },
  { label: 'Paid', value: DEPOSIT_STATUS_VALUES.PAID },
  { label: 'Unpaid', value: DEPOSIT_STATUS_VALUES.UNPAID },
  { label: 'No Deposit', value: DEPOSIT_STATUS_VALUES.NO_DEPOSIT },
];

export const UNASSIGNED_RESOURCE_ID = 'UNASSIGNED';
export const UNASSIGNED_RESOURCE_COLOR = '#9E9E9E';

export const stripUnassignedId = (ids: string[] | undefined) =>
  ids?.filter(id => id !== UNASSIGNED_RESOURCE_ID);
